import { render } from "./TheTeamInfo.vue?vue&type=template&id=52bc20de&scoped=true"
import script from "./TheTeamInfo.vue?vue&type=script&lang=js"
export * from "./TheTeamInfo.vue?vue&type=script&lang=js"

import "./TheTeamInfo.vue?vue&type=style&index=0&id=52bc20de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bc20de"]])

export default __exports__